import React from "react";
import QRCode from "qrcode.react";
import { useSelector } from "react-redux";


function QAScanner() {
	const userData = useSelector((state) => state.AuthReducer.users);
	const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
	// console.log(userData, 'userDatauserDatauserDatauserDatauserData');
	// console.log(ImageUrlRedux, 'ImageUrlReduxImageUrlReduxImageUrlRedux');

	return (
		<img className="my-2 mb-4" height={200} width={200} src={`${ImageUrlRedux?.customer_qr_image_url}/${userData?.qr_code}`}/>
		// <QRCode
		// 	id="qr-gen"
		// 	size={150}
		// 	level={"H"}
		// 	includeMargin={false}
		// 	style={{ margin: "20px 0px" }}
		// />
	);
}

export default QAScanner;
